import { BsFillCheckCircleFill, BsFillXCircleFill } from "react-icons/bs";
import { ImSpinner8 } from "react-icons/im";

export enum alertType {
  SUCCESS,
  ERROR,
  NONE,
  PROCESSING,
}

export function getAlertClass(alertTypeParam: alertType) {
  const alertTypes = {
    [alertType.SUCCESS]: "bg-green-700",
    [alertType.ERROR]: "bg-red-700",
    [alertType.PROCESSING]: "bg-gray-600",
    [alertType.NONE]: "",
  };

  return alertTypes[alertTypeParam] ?? alertType.NONE;
}

export function getAlertIcon(alertTypeParam: alertType) {
  const alertTypeIcons = {
    [alertType.SUCCESS]: <BsFillCheckCircleFill />,
    [alertType.ERROR]: <BsFillXCircleFill />,
    [alertType.PROCESSING]: <ImSpinner8 className="animate-spin" />,
    [alertType.NONE]: "",
  };
  return alertTypeIcons[alertTypeParam] ?? alertType.NONE;
}
